/* eslint-disable */
export const freeCancelingService = (e) => {
	e.preventDefault();
	e.stopPropagation();
	window.open('https://travelata-promo.ru/freecancellation', '_blank');
};